import React from 'react';
import clsx from 'clsx';

import {toVND} from '../../utils';

import styles from './PriceDisplayDiscount.module.css';


function PriceDisplayDiscount(props: { num: number, s: string, reducedName: string }) {
  return (
    <div className={clsx(styles.price, styles.discount)} data-manabie="PriceDisplay-discount-reason">
      -{toVND(props.num)} {props.s} {props.reducedName}
    </div>
  )
}

export default PriceDisplayDiscount